(() => {
  'use strict';

  const SOURCE_SELECTOR = '#CartDrawer shopify-accelerated-checkout-cart';
  const TARGET_ID = 'zp-supercart-express-target';
  const READY_CLASS = 'zp-supercart-express-ready';
  let scheduled = false;

  const addStyles = () => {
    if (document.getElementById('zp-supercart-express-styles')) return;

    const style = document.createElement('style');
    style.id = 'zp-supercart-express-styles';
    style.textContent = `
      #${TARGET_ID} {
        display: block;
        margin: 10px auto 0;
        max-width: 500px;
        width: 100%;
      }
      #${TARGET_ID}::before {
        color: #444;
        content: 'Oder schneller bezahlen mit';
        display: block;
        font-size: 15px;
        letter-spacing: .02em;
        margin: 0 0 8px;
        text-align: center;
      }
      #${TARGET_ID}:empty {
        display: none;
      }
      #${TARGET_ID} shopify-accelerated-checkout-cart {
        --shopify-accelerated-checkout-button-block-size: 42px;
        --shopify-accelerated-checkout-button-inline-size: 54px;
        --shopify-accelerated-checkout-button-border-radius: 6px;
        --shopify-accelerated-checkout-button-box-shadow: none;
        --shopify-accelerated-checkout-inline-alignment: center;
        --shopify-accelerated-checkout-row-gap: 8px;
        display: block;
        width: 100%;
      }
      @media (min-width: 769px) {
        #supercart_form_footer {
          align-items: end;
          column-gap: 16px;
          display: grid;
          grid-template-columns: minmax(280px, 420px) minmax(360px, 500px);
          justify-content: center;
        }
        #supercart_form_footer > .super-cart-form {
          grid-column: 1;
          grid-row: 1;
          align-self: end;
          margin: 0;
        }
        #supercart_form_footer .supercart-checkout {
          font-size: 16px;
          min-height: 54px;
          max-width: 420px;
          padding-inline: 24px;
          width: 100%;
        }
        #${TARGET_ID} {
          grid-column: 2;
          grid-row: 1;
          align-self: end;
          margin-top: 0;
        }
        #supercart_form_footer > .text-xs {
          grid-column: 1 / -1;
          grid-row: 2;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getTarget = () => {
    const existing = document.getElementById(TARGET_ID);
    if (existing) return existing;

    const footer = document.querySelector('#supercart_form_footer');
    if (!footer) return null;

    const target = document.createElement('div');
    target.id = TARGET_ID;
    target.setAttribute('aria-label', 'Express-Zahlung');

    const checkoutForm = footer.querySelector('form.super-cart-form');
    if (checkoutForm) {
      checkoutForm.insertAdjacentElement('afterend', target);
    } else {
      footer.prepend(target);
    }

    return target;
  };

  const syncButtons = () => {
    scheduled = false;

    const source = document.querySelector(SOURCE_SELECTOR);
    const target = getTarget();
    if (!source || !target) return;

    const sourceCartId = source.getAttribute('cart-id') || '';
    const sourceWallets = source.getAttribute('wallet-configs') || '';
    const current = target.querySelector('shopify-accelerated-checkout-cart');
    const currentCartId = current ? current.getAttribute('cart-id') || '' : '';
    const currentWallets = current ? current.getAttribute('wallet-configs') || '' : '';

    if (
      !current ||
      currentCartId !== sourceCartId ||
      currentWallets !== sourceWallets
    ) {
      target.innerHTML = source.outerHTML;
    }

    const block = target.closest('.supercart-footer');
    if (block) block.classList.add(READY_CLASS);
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(syncButtons);
  };

  const start = () => {
    addStyles();
    scheduleSync();

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    ['ajaxProduct:added', 'cart:updated', 'cart:build'].forEach((eventName) => {
      document.addEventListener(eventName, scheduleSync);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
